<div class="c-trophy">
  <div
    class="c-trophy__background"
    theming
    themingGroup="none"
    [themingAsset]="
      status() === 'COMPLETED'
        ? 'pl-trophy-modal-background-trophy-box-on'
        : 'pl-trophy-modal-background-trophy-box-off'
    ">
    <div class="c-trophy__background__content">
      <span class="e-title">
        {{ 'home.trophies.' + trophyNameCamelCase() | translate }}
      </span>

      <div class="e-trophySlot">
        <img
          class="e-trophySlot__image"
          [ngClass]="{
            'e-trophySlot__image--progress': status() === 'PROGRESSING'
          }"
          [src]="trophyImage()"
          alt="Trophy" />

        @if (status() === 'PROGRESSING') {
          <slotcom-round-progress
            class="e-trophySlot__roundProgress"
            [milestoneKey]="trophy().trophy"
            [current]="trophy().current"
            [total]="trophy().total"
            backgroundColor="#16023D">
          </slotcom-round-progress>

          <div class="e-trophySlot__progressBar">
            <span
              >{{ trophy().current | notRoundingBeautifyNumber: ('common.culture' | translate) }}/{{
                trophy().total | notRoundingBeautifyNumber: ('common.culture' | translate)
              }}</span
            >
          </div>

          <div class="e-trophySlot__display">
            <slotcom-display [classes]="['c-display--milestone']">
              <div
                class="icon"
                displayIcon
                displayIconPos="left"
                theming
                themingGroup="progressline"
                themingAsset="prestige-logo"></div>
              {{ trophy().reward.quantity | notRoundingBeautifyNumber: ('common.culture' | translate) }}
            </slotcom-display>
          </div>
        }

        @if (status() === 'COMPLETED') {
          <img
            class="e-trophySlot__trophyCheck"
            [src]="checkIcon"
            [alt]="checkIcon" />
        }
      </div>

      @if (status() === 'BLOCKED') {
        <div
          class="e-blocked"
          (pointerenter)="onPointerEnter($event)"
          (pointerleave)="onPointerLeave($event)"
          (pointerdown)="onPointerDown($event)"
          (click)="onClick()">
          <span
            class="e-blocked__text"
            [ngClass]="{ 'is-visible': showBlockedText() }"
            >{{ 'home.trophies-modal.blocked.trophy.text' | translate }}</span
          >

          <img
            class="e-blocked__lockIcon"
            [src]="lockIcon"
            alt="lock-icon" />
        </div>
      }
    </div>
  </div>
</div>
